import React, { forwardRef, useState } from 'react';

import Colors from 'common/colors/constants';
import { isHexColor } from 'common/colors/utils';
import Input from 'common/uiV3/Input';

type ColorInputProps = {
  defaultValue?: string;
  onChange?: (value: string) => void;
};

const ColorInput = forwardRef<HTMLInputElement, ColorInputProps>(
  ({ defaultValue, onChange }, ref) => {
    const [value, setValue] = useState(defaultValue ? defaultValue.toLowerCase() : '');

    const onTextChange = (text: string) => {
      if (text === '' || text === '#') {
        setValue(text);
        onChange?.(text);
        return;
      }

      const nonHex = /[^0-9a-f]/gi;
      text = text.replace(nonHex, '');
      text = '#' + text.substr(0, 6);

      setValue(text);
      onChange?.(text);
    };

    const renderPreview = () => {
      const color = isHexColor(value) ? value : Colors.white;

      return (
        <div
          className="size-5 rounded-md transition-colors duration-200"
          style={{ backgroundColor: color }}
        />
      );
    };

    return (
      <Input
        ref={ref}
        value={value}
        placeholder="#000000"
        onChange={onTextChange}
        suffix={renderPreview()}
      />
    );
  },
);

ColorInput.displayName = 'ColorInput';

export default ColorInput;
